import { render, staticRenderFns } from "./CodeArea.vue?vue&type=template&id=ed060ef0&"
import script from "./CodeArea.vue?vue&type=script&lang=js&"
export * from "./CodeArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports